import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash, FaPlus, FaCheck, FaTimes, FaMapMarkerAlt, FaSpinner } from "react-icons/fa";
import API_URL from "../config";
import "./Settings.css";

export default function Settings({ entrepriseId }) {
  const [siteName, setSiteName] = useState("");
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [editingSite, setEditingSite] = useState(null);

  const SITES_API = `${API_URL}/api/sites`;

  const fetchSites = async () => {
    setFetching(true);
    try {
      const res = await fetch(`${SITES_API}/${entrepriseId}`);
      if (!res.ok) throw new Error("Erreur réseau");
      const data = await res.json();
      setSites(data);
    } catch (err) {
      setErrorMsg("Impossible de charger les sites.");
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    fetchSites();
  }, [entrepriseId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!siteName.trim()) return;

    setLoading(true);
    setSuccessMsg("");
    setErrorMsg("");

    try {
      let res;
      if (editingSite) {
        res = await fetch(`${SITES_API}/${editingSite.id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ nom: siteName }),
        });
      } else {
        res = await fetch(SITES_API, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ nom: siteName, entrepriseId }),
        });
      }

      if (!res.ok) throw new Error("Échec de l'opération");

      setSuccessMsg(editingSite ? "Site mis à jour !" : "Nouveau site ajouté !");
      setSiteName("");
      setEditingSite(null);
      fetchSites();
      
      // Auto-hide success message
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch (err) {
      setErrorMsg("Une erreur est survenue.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (siteId) => {
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer ce site ?")) return;
    try {
      const res = await fetch(`${SITES_API}/${siteId}`, { method: "DELETE" });
      if (!res.ok) throw new Error("Erreur");
      setSuccessMsg("Site supprimé.");
      fetchSites();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch (err) {
      setErrorMsg("Erreur lors de la suppression.");
    }
  };

  return (
    <div className="settings-page">
      <header className="settings-header">
        <div className="header-info">
          <h1>Configuration</h1>
          <p>Gérez les emplacements physiques (boutiques) de votre entreprise</p>
        </div>
      </header>

      <div className="settings-grid">
        {/* Formulaire - Section Gauche */}
        <div className="settings-card form-section">
          <h3>{editingSite ? "Modifier l'emplacement" : "Nouvel emplacement"}</h3>
          <form onSubmit={handleSubmit} className="modern-form">
            <div className="input-container">
              <label>Nom de la boutique</label>
              <div className="input-with-icon">
                <FaMapMarkerAlt className="input-icon" />
                <input
                  type="text"
                  value={siteName}
                  onChange={(e) => setSiteName(e.target.value)}
                  placeholder="Ex: Entrepôt Nord, Agence Centre..."
                  required
                />
              </div>
            </div>
            
            <div className="form-actions">
              <button type="submit" disabled={loading} className="btn-save">
                {loading ? <FaSpinner className="spin" /> : editingSite ? <FaCheck /> : <FaPlus />}
                {editingSite ? "Enregistrer" : "Créer le site"}
              </button>
              
              {editingSite && (
                <button
                  type="button"
                  onClick={() => { setEditingSite(null); setSiteName(""); }}
                  className="btn-cancel"
                >
                  Annuler
                </button>
              )}
            </div>
          </form>

          {successMsg && <div className="toast success">{successMsg}</div>}
          {errorMsg && <div className="toast error">{errorMsg}</div>}
        </div>

        {/* Liste - Section Droite */}
        <div className="settings-card list-section">
          <div className="list-header">
            <h3>Boutiques enregistrés</h3>
            <span className="count-tag">{sites.length}</span>
          </div>

          {fetching ? (
            <div className="list-loading"><FaSpinner className="spin" /></div>
          ) : (
            <div className="custom-list">
              {sites.length === 0 ? (
                <div className="empty-state">Aucune boutique configuré.</div>
              ) : (
                sites.map((site) => (
                  <div key={site.id} className="custom-list-item">
                    <div className="item-info">
                      <div className="avatar">{site.nom.charAt(0).toUpperCase()}</div>
                      <span>{site.nom}</span>
                    </div>
                    <div className="item-actions">
                      <button onClick={() => { setEditingSite(site); setSiteName(site.nom); }} className="action-btn edit" title="Editer">
                        <FaEdit />
                      </button>
                      <button onClick={() => handleDelete(site.id)} className="action-btn delete" title="Supprimer">
                        <FaTrash />
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}